import { ComponentProps } from 'react';
import BordPhoto from '../NudosComponents/BordPhoto/BordPhoto';
import { IUserData } from '../../types/orders';
import NudosHoverText from '../NudosComponents/NudosHoverText/NudosHoverText';
import { TBordPhotoSize } from '../NudosComponents/BordPhoto/BordPhoto.types';

import './UserInfo.scss';

interface UserInfoProps extends IUserData {
  imageProps?: ComponentProps<'img'>;
  limitCharacters?: number;
  bordPhotoSize?: TBordPhotoSize;
}

const UserInfo = ({
  profilePhoto,
  firstName,
  lastName,
  email,
  imageProps = {
    style: {
      objectFit: 'cover',
      borderRadius: '100%',
      width: '20px',
      height: '20px'
    }
  },
  limitCharacters = 24,
  bordPhotoSize = 's20'
}: UserInfoProps) => {
  return (
    <div className="userInfo">
      <BordPhoto imageProps={imageProps} url={profilePhoto} size={bordPhotoSize} variant="circle" avatarProps={{ variant: 'circularUser' }} />
      <div className="userInfoContent">
        <NudosHoverText
          onlyIfTruncated
          customClassName="userName"
          text={`${firstName} ${lastName ?? ''}`}
          charactersLimit={limitCharacters}
        />
        <div className="userEmail">
          <NudosHoverText onlyIfTruncated text={email ?? 'No disponible'} charactersLimit={limitCharacters} />
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
